<template>
  <div>
<FormRow class="designation">
  <FormSelect field="custom.designation">
    <option selected="selected" value="General Donation">General Donation</option>
    <option value="Summer Scholarship">Yachad Summer Scholarships</option>
    <option value="Summer Programs">Yachad Summer Camp/Program</option>
    <option value="Yad b’Yad">Yad B'Yad</option>
  </FormSelect>

</FormRow>
<FormRow class="subdesignation">
<div class="program-designation" v-if="getValue('custom.designation') == 'Summer Programs'">
<FormLabel>Is there a specific Yachad Summer Camp/Program<br> that you would like to direct your donation to?</FormLabel>
  <FormSelect field="custom.subDesignation">
    <option selected="selected" value="Summer Programs">General Yachad Summer Programs</option>
        <option value="Birthright Israel">Birthright Israel</option>
        <option value="Camp Amichai">Camp Amichai</option>
        <option value="Camp Chaverim">Chaverim</option>
        <option value="Getaway">Getaway</option>
        <option value="Camp Kesher">Kesher</option>
        <option value="Camp Lavi">Lavi</option>
        <option value="Camp Mesorah">Mesorah</option>
        <option value="Camp Morasha">Morasha</option>
        <option value="Moshava Alevy">Moshava Alevy</option>
        <option value="Moshava Ba'ir NJ (MBNJ)">Moshava Ba’ir NJ</option>
        <option value="Moshava Ba'ir Toronto (MBT)">Moshava Ba’ir Toronto</option>
        <option value="Moshava Ennismore">Moshava Ennismore</option>
        <option value="Moshava IO (Indian Orchard, PA)">Moshava IO</option>
        <option value="Moshava Wild Rose">Moshava Wild Rose</option>
        <option value="Nofesh">Nofesh</option>
        <option value="Camp Nesher">Nesher</option>
        <option value="Sephardic Adventure Camp">Sephardic Adventure Camp</option>
        <option value="Simcha Day Camp">Simcha Day Camp</option>
        <option value="Yachad BaChutz">Yachad BaChutz</option>
        <option value="Yad B’Yad">Yad B’Yad</option>
    </FormSelect>
  </div>

  <ErrorLabel field="custom.designation" style="text-align:right"/>
</FormRow>
</div>
</template>
<script lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form';
import { defineComponent, watch } from "vue";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { getValue, settings, setValue, form } = usePaymentForm();

    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Summer Scholarship" || !val) {
          setValue("applications.0.department", "Yachad_Summer");
          setValue("applications.0.campaign", "Summer Scholarship");
        } 
        else if(val == "Yad b’Yad" || !val) {
          setValue("applications.0.department", "Yachad_Summer");
          setValue("applications.0.campaign", "Yad B'Yad (YBY)");
        } 
        else {
          setValue("applications.0.department", "Yachad_Summer");
          setValue("applications.0.campaign", "General Donation");
          // setValue("applications.0.campaign", val);
        }
      }
    );



    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if(val == "Birthright Israel" || !val) {
          setValue("applications.0.campaign", "Birthright Israel");
         } 
        else if(val == "Camp Amichai" || !val) {
          setValue("applications.0.campaign", "Camp Amichai");
        } 
        else if(val == "Camp Chaverim" || !val) {
          setValue("applications.0.campaign", "Camp Chaverim");
        } 
        else if(val == "Getaway" || !val) {
          setValue("applications.0.campaign", "Getaway");
        } 
        else if(val == "Camp Kesher" || !val) {
          setValue("applications.0.campaign", "Camp Kesher");
        } 
        else if(val == "Camp Lavi" || !val) {
          setValue("applications.0.campaign", "Camp Lavi");
        } 
        else if(val == "Camp Mesorah" || !val) {
          setValue("applications.0.campaign", "Camp Mesorah");
        } 
        else if(val == "Camp Morasha" || !val) {
          setValue("applications.0.campaign", "Camp Morasha");
        } 
        else if(val == "Moshava Alevy" || !val) {
          setValue("applications.0.campaign", "Moshava Alevy");
        } 
        else if(val == "Moshava Ba'ir NJ (MBNJ)" || !val) {
          setValue("applications.0.campaign", "Moshava Ba'ir NJ (MBNJ)");
        } 
        else if(val == "Moshava Ba'ir Toronto (MBT)" || !val) {
          setValue("applications.0.campaign", "	Moshava Ba'ir Toronto (MBT)");
        } 
        else if(val == "Moshava Ennismore" || !val) {
          setValue("applications.0.campaign", "Moshava Ennismore");
        } 
        else if(val == "Moshava IO (Indian Orchard, PA)" || !val) {
          setValue("applications.0.campaign", "Moshava IO (Indian Orchard, PA)");
        } 
        else if(val == "Moshava Wild Rose" || !val) {
          setValue("applications.0.campaign", "Moshava Wild Rose");
        } 
        else if(val == "Nofesh" || !val) {
          setValue("applications.0.campaign", "Nofesh");
        } 
        else if(val == "Camp Nesher" || !val) {
          setValue("applications.0.campaign", "Camp Nesher");
        } 
        else if(val == "Sephardic Adventure Camp" || !val) {
          setValue("applications.0.campaign", "Sephardic Adventure Camp");
        } 
        else if(val == "Simcha Day Camp" || !val) {
          setValue("applications.0.campaign", "Simcha Day Camp");
        } 
        else if(val == "Yachad BaChutz" || !val) {
          setValue("applications.0.campaign", "Yachad BaChutz");
        } 
        else if(val == "Yad B'Yad" || !val) {
          setValue("applications.0.campaign", "Yad B'Yad (YBY)");
        } 
        else {
          setValue("applications.0.department", "Yachad_Summer");
          setValue("applications.0.campaign", val);
        }
      }
    );



    return {
      form,
      getValue,
      settings,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width:75%;
    max-width:75%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
  ::v-deep label{
    padding-top: 10px;
    padding-bottom: 7px;
    display: block;
    font-size: 14px;
    color: #222;
    max-width: 100%;
    letter-spacing: normal;
    line-height: 1.4;
  }
}
.subdesignation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width:100%;
    max-width:100%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
  ::v-deep label{
    padding-top: 10px;
    padding-bottom: 7px;
    display: block;
    font-size: 14px;
    color: #222;
    max-width: 100%;
    line-height: 1.4;
    text-transform: none;
    font-weight: 500;
  }
}
</style>